import React from 'react'
import { Box, Typography, Container } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PackagesContainer from '@talentinc/gatsby-theme-ecom/components/Packages/PackagesContainer'

interface Props {
  variant?: string
  sectionClass?: string
}

const PurchaseFooter: React.FC<Props> = ({ variant = null, sectionClass }) => {
  const { classes, cx } = useStyles()
  const { i18n } = useTranslation()
  const tRef = 'zipjob-purchase-footer'

  return (
    <Container
      className={cx(sectionClass, classes.main, {
        [classes.mainInPost]: variant === 'inPost',
      })}
      disableGutters
    >
      <Box
        className={cx(classes.header, {
          [classes.headerInPost]: variant === 'inPost',
        })}
      >
        <Typography variant="h1" className={classes.heading} component="h4">
          {variant === 'inPost'
            ? (i18n.t(`${tRef}.titleInPost`) as string)
            : (i18n.t(`${tRef}.title`) as string)}
        </Typography>
        {variant !== 'inPost' && (
          <Typography variant="h2" className={classes.subtitle} component="h5">
            {i18n.t(`${tRef}.subtitle`) as string}
          </Typography>
        )}
      </Box>
      <PackagesContainer variant={variant} />
    </Container>
  )
}

const useStyles = makeStyles()((theme) => ({
  cards: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',

    '& > div': {
      margin: '0 1em',
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& > div': {
        margin: '1em 0',
      },
    },
  },
  cardsInPost: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  container: {
    margin: '0',
    width: '18.25em',

    [theme.breakpoints.down('md')]: {
      maxWidth: '18.25em',
      width: '32%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1em 0',
      maxWidth: 'initial',
      width: '100%',
    },
  },
  containerInPost: {
    maxWidth: '32.5%',

    [theme.breakpoints.down('md')]: {
      margin: '1em 0',
      maxWidth: 'unset',
      width: '100%',
    },
  },
  header: {
    marginBottom: '3em',
    textAlign: 'center',

    [theme.breakpoints.down('sm')]: {
      marginBottom: '.95em',
      textAlign: 'left',
      paddingInline: '6%',
    },
  },
  headerInPost: {
    fontSize: '.81em',
    marginBottom: '2.22em',

    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
      textAlign: 'center',

      '& h4': {
        textAlign: 'center',
      },
    },
  },
  heading: {
    letterSpacing: '.02em',
    marginBottom: '.5em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.81em',
      marginBottom: '.95em',
      textAlign: 'left',
    },
  },
  subtitle: {
    fontWeight: 'normal',
    fontSize: '1.125em',
  },
  main: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    paddingBottom: '4.56em',
    paddingTop: '4.16em',
    position: 'relative',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      paddingBottom: '3.46em',
      paddingTop: '2.81em',
    },
  },
  mainInPost: {
    padding: '2.84em 2em 2em',
  },
}))

export default PurchaseFooter
